export default "__VITE_ASSET__d9fe6e90__"